function cpProductSlider() {
  const sliders = document.querySelectorAll("[data-slider]");
  sliders.forEach((slider) => {
    const sliderInner = slider.querySelector(".cp-product-slider-inner");
    if (sliderInner && sliderInner.children.length > 1) {
      const config = JSON.parse(sliderInner.getAttribute("data-config"));
      const flkty = new Flickity(sliderInner, config);
      sliderInner.flickityInstance = flkty;
    }
  });
}
cpProductSlider();

/* bundle builder */
/* variant picker */
// jQuery.event.special.touchstart = {
//   setup: function (_, ns, handle) {
//     this.addEventListener('touchstart', handle, { passive: true });
//   }
// };
// jQuery.event.special.touchmove = {
//   setup: function (_, ns, handle) {
//     this.addEventListener('touchmove', handle, { passive: true });
//   }
// };

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

function updateBundlePrice(totalPrice, totalComparePrice) {
  console.log(totalPrice, totalComparePrice);
  let productPrices = document.querySelector("[data-product-price-list]"),
    productLabelList = document.querySelector("[data-product-label-list]"),
    currencyFormat = window.themeVariables.settings.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : window.themeVariables.settings.moneyFormat;

  if (!productPrices || !productLabelList) {
    return;
  }

  totalPrice = parseFloat(totalPrice) || 0;
  totalComparePrice = parseFloat(totalComparePrice) || 0;

  if (!totalPrice) {
    // productPrices.style.display = "none";
  } else {
    productPrices.innerHTML = "";

    if (totalComparePrice > totalPrice) {
      productPrices.innerHTML += `<span class="price price--highlight">
        <span class="visually-hidden">${
          window.themeVariables.strings.productSalePrice
        }</span>
        ${formatMoney(totalPrice, currencyFormat)}
      </span>`;
      productPrices.innerHTML += `<span class="price price--compare">
        <span class="visually-hidden">${
          window.themeVariables.strings.productRegularPrice
        }</span>
        ${formatMoney(totalComparePrice, currencyFormat)}
      </span>`;
    } else {
      productPrices.innerHTML += `<span class="price">
        <span class="visually-hidden">${
          window.themeVariables.strings.productSalePrice
        }</span>
        ${formatMoney(totalPrice, currencyFormat)}
      </span>`;
    }
    productPrices.style.display = "";
  }

  // productLabelList.innerHTML = "";

  if (!totalComparePrice) {
    // productLabelList.innerHTML = `<span class="label label--subdued">${window.themeVariables.strings.collectionSoldOut}</span>`;
  } else if (totalComparePrice > totalPrice) {
    let savings = "";
    if (window.themeVariables.settings.discountMode === "percentage") {
      savings = `${Math.round(
        ((totalComparePrice - totalPrice) * 100) / totalComparePrice
      )}%`;
    } else {
      savings = formatMoney(totalComparePrice - totalPrice, currencyFormat);
    }

    // productLabelList.innerHTML = `<span class="label label--highlight">${window.themeVariables.strings.collectionDiscount.replace(
    //   "@savings@",
    //   savings
    // )}</span>`;
  }
}
function bundleSearch() {
  $(".bundle-search").click(function () {
    $("#bundle-search-input").slideToggle(0);
    $(".product-bundle-popup").toggleClass("search_open");
  });
  var bundleSearchInput = document.getElementById("bundle-search-input");
  var bundleProducts = document.querySelectorAll(
    ".bundle-popup-products-block-product"
  );
  var bundleSectionContent = document.querySelector(
    ".product-bundle-popup-content"
  );

  if (bundleSearchInput !== null) {
    bundleSearchInput.addEventListener("input", function () {
      console.log("yes");
      var inputValue = bundleSearchInput.value.trim().toLowerCase();
      bundleProducts.forEach(function (item) {
        item.classList.remove("show_insearch");
      });

      if (inputValue === "") {
        if (bundleSectionContent !== null) {
          bundleSectionContent.classList.add("show_all");
          bundleSectionContent.classList.remove("not_show_all");
        }
      } else {
        if (bundleSectionContent !== null) {
          bundleSectionContent.classList.add("not_show_all");
          bundleSectionContent.classList.remove("show_all");
        }

        bundleProducts.forEach(function (item) {
          var t = item.getAttribute("data-title").toLowerCase();
          if (t.includes(inputValue)) {
            item.classList.add("show_insearch");
          }
        });
      }
    });
  }
}

// function bundle_slider() {
//   var $slider = $(".bundle-product-images");
//   if ($slider.hasClass("slick-initialized")) {
//     $slider.slick("unslick");
//   }
//   $slider.slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     dots: true,
//     arrows: false,
//   });
// }
// bundle_slider();

function updateProgressBar(bundleData) {
  const threshold = parseFloat(
    document.querySelector(".bundle-progressbar").getAttribute("threshold")
  );
  const activeProductsLength = bundleData.activeProductsLength;

  let progress = (activeProductsLength / threshold) * 100;
  if (progress > 100) progress = 100;

  const progressBarActive = document.querySelector(
    ".bundle-progressbar-active"
  );
  if (progressBarActive) {
    progressBarActive.style.width = progress + "%";
  }

  const progressMessage = document.getElementById("progressMessage");
  const blocks = document.querySelectorAll(".progressbar-discount");
  const bundle_price = document.querySelector(".bundle-total-price");

  let appliedDiscount = 0;
  let nearestThreshold = null;
  let nearestDiscount = null;
  let remainingProducts = null;

  blocks.forEach((block) => {
    const blockThreshold = parseInt(
      block.querySelector(".treshold").getAttribute("data-value"),
      10
    );
    const discount = parseFloat(
      block.querySelector(".discount-label").getAttribute("data-value")
    );

    if (activeProductsLength >= blockThreshold) {
      block.classList.add("active");
      appliedDiscount = discount;
    } else if (nearestThreshold === null) {
      nearestThreshold = blockThreshold;
      nearestDiscount = discount;
      remainingProducts = blockThreshold - activeProductsLength;
    }
  });

  let message = "";
  if (progress === 100) {
    message = progressbar_message_after;
  } else if (nearestThreshold !== null) {
    message = progressbar_message
      .replace("[amount]", `<strong>${remainingProducts}</strong>`)
      .replace("[discount]", `<strong>${nearestDiscount}%</strong>`);
  }

  if (progressMessage) {
    progressMessage.innerHTML = message;
  }

  const comparePrice = (bundleData.totalDataP / 100).toFixed(2);
  const salePrice = (
    Math.ceil((bundleData.totalDataP * (100 - appliedDiscount)) / 100) / 100
  ).toFixed(2);
  const savedAmount = (
    parseFloat(comparePrice) - parseFloat(salePrice)
  ).toFixed(2);

  updateBundlePrice(
    Math.ceil((bundleData.totalDataP * (100 - appliedDiscount)) / 100),
    bundleData.totalDataP
  );
  if (comparePrice !== salePrice) {
    bundle_price.innerHTML = `<del>${comparePrice}€</del>  <strong>${salePrice}€</strong> <span class="saved">(Du sparst ${savedAmount}€)</span>`;
  } else {
    bundle_price.innerHTML = `<strong>${salePrice}€</strong>`;
  }
}
function getSiblingWithClass(element, className) {
  if (element.classList.contains(className)) {
    return element;
  }
  let sibling = element.nextElementSibling;

  while (sibling) {
    if (sibling.classList.contains(className)) {
      return sibling;
    }
    sibling = sibling.nextElementSibling;
  }

  sibling = element.previousElementSibling;

  while (sibling) {
    if (sibling.classList.contains(className)) {
      return sibling;
    }
    sibling = sibling.previousElementSibling;
  }
  return null;
}

window.addEventListener("DOMContentLoaded", function () {
  var productContainers = document.querySelectorAll(".product-container");

  productContainers.forEach(function (container) {
    var dataVariants = container.getAttribute("data-variants");
    var variants = JSON.parse(dataVariants);
    var swatches = container.querySelectorAll(".swatch");

    swatches.forEach(function (swatch) {
      swatch.addEventListener("click", function () {
        const swatchContainer = this.closest(".swatch-container");
        swatchContainer.querySelector(".selected_option span").textContent =
          this.getAttribute("data-value");
        swatchContainer
          .querySelector(".selected_option")
          .classList.remove("active");
        const swatchList = Array.from(
          swatchContainer.querySelectorAll(".swatch")
        );
        swatchList.forEach((s) => s.classList.remove("active"));
        this.classList.add("active");

        var selectedOptions = [];
        var optionContainers = container.querySelectorAll(".swatch-container");

        optionContainers.forEach(function (optionContainer) {
          var activeSwatch = optionContainer.querySelector(".swatch.active");
          if (activeSwatch) {
            selectedOptions.push(activeSwatch.getAttribute("data-value"));
          } else {
            selectedOptions.push(null);
          }
        });

        var selectedVariant = findVariant(variants, selectedOptions);
        if (selectedVariant) {
          container.setAttribute("data-variant-selected", selectedVariant.id);
          updateSoldOutStates(container, variants, selectedOptions);
          $(container)
            .siblings(".select_btn")
            .attr("data-vid", selectedVariant.id);
          if (selectedVariant.available) {
            $(container).siblings(".select_btn").removeClass("soldout");
          } else {
            $(container).siblings(".select_btn").addClass("soldout");
          }
          var product_wrapper = this.closest(
            ".bundle-popup-products-block-product"
          );

          if (selectedVariant && selectedVariant.featured_image) {
            const imageElement = product_wrapper.querySelector(
              ".bundle-popup-products-block-product-img"
            );
            imageElement.src = selectedVariant.featured_image.src;
            imageElement.srcset = `${selectedVariant.featured_image.src} 300w`;
          }
          product_wrapper.setAttribute("data-p", selectedVariant.price);
          product_wrapper.setAttribute(
            "data-cp",
            selectedVariant.compare_at_price
          );
        }
      });
    });
  });

  const selectedOptions = document.querySelectorAll(
    ".swatch-container .selected_option"
  );

  selectedOptions.forEach(function (selectedOption) {
    selectedOption.addEventListener("click", function (event) {
      event.stopPropagation();
      this.classList.toggle("active");
    });
  });

  document.addEventListener("click", function (event) {
    selectedOptions.forEach(function (selectedOption) {
      if (!selectedOption.contains(event.target)) {
        selectedOption.classList.remove("active");
      }
    });
  });
});

function findVariant(variants, selectedOptions) {
  return variants.find(
    (variant) =>
      variant.option1 == selectedOptions[0] &&
      variant.option2 == selectedOptions[1] &&
      variant.option3 == selectedOptions[2]
  );
}

function updateSoldOutStates(container, variants, selectedOptions) {
  const optionContainers = container.querySelectorAll(".swatch-container");

  optionContainers.forEach(function (optionContainer, index) {
    const swatches = optionContainer.querySelectorAll(".swatch");

    swatches.forEach(function (swatch) {
      const value = swatch.getAttribute("data-value");
      const currentSelectedOptions = [...selectedOptions];
      currentSelectedOptions[index] = value;

      const matchingVariant = findVariant(variants, currentSelectedOptions);
      if (matchingVariant && !matchingVariant.available) {
        swatch.classList.add("soldout_variant");
      } else {
        swatch.classList.remove("soldout_variant");
      }
    });
  });
}
/* variant picker */

try {
  $("body").delegate(".parent_item .quantity-selector", "click", function () {
    document.body.classList.add("refreshing_cart");
    setTimeout(function () {
      document.body.classList.remove("refreshing_cart");
    }, 6000);
  });

  $("body").delegate(
    ".parent_item .line-item__remove-button",
    "click",
    function () {
      document.body.classList.add("refreshing_cart");
      setTimeout(function () {
        document.body.classList.remove("refreshing_cart");
      }, 6000);
    }
  );
} catch (e) {}
$(function () {
  function updateVisibility() {
    const productBundles = document.querySelectorAll(
      ".product-bundle-products-selection"
    );

    productBundles.forEach((bundle) => {
      const continuousElements = bundle.querySelectorAll(
        ".product-bundle-add-product.continuous"
      );
      const allProductElements = bundle.querySelectorAll(
        ".product-bundle-add-product"
      );
      continuousElements.forEach((element) => {
        element.style.display = "none";
      });

      let allNonContinuousAdded = true;
      for (let i = 0; i < allProductElements.length; i++) {
        if (
          !allProductElements[i].classList.contains("continuous") &&
          !allProductElements[i].classList.contains("added")
        ) {
          allNonContinuousAdded = false;
          break;
        }
      }

      continuousElements.forEach((element, index) => {
        // if (index === 0) {
        //   element.style.display = "block";
        //   return;
        // }

        let allPreviousContinuousAdded = true;
        for (let i = 0; i < index; i++) {
          if (continuousElements[i].classList.contains("added") === false) {
            allPreviousContinuousAdded = false;
            break;
          }
        }

        if (allNonContinuousAdded && allPreviousContinuousAdded) {
          element.style.display = "block";
        } else {
          element.style.display = "none";
        }
      });
    });
  }

  updateVisibility();

  updateDOM(activeProducts);
  function bundleProductClose() {
    $(".product-bundle-popup-overlay").removeClass("open");
    $(".product-bundle-popup").removeClass("open");
    $("body").removeClass("bundle-open");
  }
  function stepProducts(step) {
    var originalStep = step;
    if (step) {
      var step = step;
      $(".product-bundle-products-selection").each(function () {
        var firstBlank = $(this).find(
          ".product-bundle-add-product:not(.added):first"
        );
        $(".product-bundle-add-product").removeClass("first-blank");
        $(firstBlank).addClass("first-blank");
        step = $(firstBlank).attr("data-step");
      });
      step = step ? step : originalStep;
      if (originalStep) {
        step = originalStep;
      }
      $(
        ".bundle-popup-products .bundle-popup-products-block-wrapper"
      ).removeClass("open");
      let el = $(
        ".bundle-popup-products-block-wrapper[data-step='" + step + "']"
      );
      $(el).addClass("open");
    }
  }
  function bundleProductOpen(step) {
    $(".product-bundle-popup-overlay").addClass("open");
    $(".product-bundle-popup").addClass("open");
    $(
      ".bundle-popup-products .bundle-popup-products-block-wrapper"
    ).removeClass("open");

    if (step) {
      stepProducts(step);
    } else {
      $(".bundle-popup-products .bundle-popup-products-block-wrapper")
        .eq(0)
        .addClass("open");
    }
    $("body").addClass("bundle-open");
  }
  $(".product-bundle-popup-overlay").click(function () {
    bundleProductClose();
  });
  $(".bundle-popup-products-block-btn").click(function (e) {
    document.querySelector("#AddToCart").click();
    setTimeout(function () {
      bundleProductClose();
    }, 1);
  });
  $(".bundle-popup-close").click(function (e) {
    bundleProductClose();
  });
  $(".product-bundle-add-product").click(function (e) {
    bundleProductOpen($(this).attr("data-step"));

    stepProducts($(this).attr("data-step"));

    $(".product-bundle-add-product").removeClass("first-blank");
    var that = this;
    $(".product-bundle-products-selection").each(function () {
      var getClicked = $(this)
        .find(".product-bundle-add-product")
        .eq($(that).index());
      $(getClicked).addClass("first-blank");
    });
  });
  function setActiveProduct(vid, title, img, step, p, cp) {
    $(".product-bundle-products-selection").each(function () {
      var removeEl = $(this).find(
        `.product-bundle-add-product[data-step="${step}"]`
      );
      $(removeEl).removeClass("added");
      $(removeEl).removeAttr("data-vid");
      $(removeEl).find(".p-img").remove();
      $(removeEl).find(".p-title").remove();
      $(removeEl).find(".step-price").remove();
    });

    $(".product-bundle-products-selection").each(function () {
      var firstElement = $(
        `.product-bundle-add-product[data-step="${step}"]:not(.added)`
      );
      firstElement.addClass("added");
      $(firstElement).attr("data-vid", vid);
      const pimg = `<img src="${img}" class="p-img">`;
      const ptitle = `<p class="p-title">${
        title.length > 35 ? title.substring(0, 25) + "..." : title
      }</p>`;
      $(firstElement).find(".product-bundle-add-product-img").append(pimg);
      firstElement.append(ptitle);

      var firstBlank = $(this).find(
        ".product-bundle-add-product:not(.added):first"
      );
      stepProducts($(firstBlank).attr("data-step"));

      var price = p / 100;
      var comprice = cp / 100;
      var priceTemp;

      if (comprice > price) {
        priceTemp = `<div class="step-price"><span class="step-price-price has-compare">€${price}</span> <span class="step-price-comprice">€${comprice}</span></div>`;
      } else {
        priceTemp = `<div class="step-price"><span class="step-price-price">€${price}</span></div>`;
      }

      firstElement.append(priceTemp);
    });
  }
  function removeActiveProduct(varaintId, index) {
    let foundFirst = false;

    activeProducts = activeProducts.filter((el) => {
      if (!foundFirst && el.vid == varaintId) {
        foundFirst = true;
        return false;
      }
      return true;
    });

    $(".product-bundle-products-selection").each(function () {
      var removeEl = $(this).find(".product-bundle-add-product").eq(index);
      $(removeEl).removeClass("added");
      $(removeEl).removeAttr("data-vid");
      $(removeEl).find(".p-img").remove();
      $(removeEl).find(".p-title").remove();
    });

    updateDOM(activeProducts);
  }
  function updateDOM(activeProducts) {
    let activeProductsLength = activeProducts.length;
    $(".number-of-selected-items").text(activeProductsLength);
    let percent = (activeProductsLength / numberOfSteps) * 100;
    $(".product-bundle-popup .progress-bar-fill").css({
      width: percent + "%",
    });
    var buttons = document.querySelectorAll(".bundle-popup-products-block-btn");
    if (activeProductsLength == numberOfSteps) {
      $(".product-bundle-wrapper").addClass("filled");
      $(".product__info #AddToCart").removeAttr("disabled");
      $("#StickyAddToCart").removeAttr("disabled");
      buttons.forEach((button) => {
        const dataText = "Set in den Warenkorb packen";

        button.textContent = dataText;
      });
    } else {
      $(".product-bundle-wrapper").removeClass("filled");

      buttons.forEach((button) => {
        const dataText = button.getAttribute("data-text");

        button.textContent = dataText;
      });
    }

    //Bundle price
    // let mainProduct = document.querySelector(".product-bundle-wrapper");

    // let mainDataP = parseFloat(mainProduct.getAttribute("data-p")) || 0;
    // let mainDataCp = mainProduct.getAttribute("data-cp");
    // mainDataCp = mainDataCp ? parseFloat(mainDataCp) : mainDataP;

    let totalDataP = activeProducts.reduce((sum, item) => sum + item.dataP, 0);
    let totalDataCp = activeProducts.reduce(
      (sum, item) => sum + item.dataCp,
      0
    );

    // totalDataP += mainDataP;
    // totalDataCp += mainDataCp;

    let formattedTotalDataP =
      (totalDataP / 100).toFixed(2).replace(".", ",") + "€";
    let formattedTotalDataCp =
      (totalDataCp / 100).toFixed(2).replace(".", ",") + "€";

    $(".bundle-total-price").text(formattedTotalDataP);
    updateProgressBar({
      totalDataP: totalDataP,
      activeProductsLength: activeProductsLength,
    });
  }
  $(".select_btn").click(function (e) {
    e.preventDefault();
    var stepAdded = false;

    let step = $(this).attr("data-step");

    for (let item of activeProducts) {
      if (item.step == step) {
        stepAdded = true;
      }
    }

    if (!$(this).hasClass("soldout")) {
      let vid = $(this).attr("data-vid");
      let title = $(this).attr("data-title");
      let img = $(this).attr("data-img");
      let index = parseInt(
        $(this)
          .parents(".bundle-popup-products-block-wrapper")
          .attr("data-index")
      );

      let productElement = this.closest(".bundle-popup-products-block-product");

      let dataCp = productElement.getAttribute("data-cp");
      let dataP = parseFloat(productElement.getAttribute("data-p"));

      dataCp =
        dataCp !== null && !isNaN(parseFloat(dataCp))
          ? parseFloat(dataCp)
          : dataP;

      let optional = $(this).attr("data-optional") === "1" ? true : false;

      activeProducts = activeProducts.filter(function (item) {
        return item.step !== step;
      });

      // if (activeProducts.length != numberOfSteps) {
      activeProducts.push({
        vid,
        title,
        img,
        step,
        dataP,
        dataCp,
        optional,
        index,
      });
      setActiveProduct(vid, title, img, step, dataP, dataCp);
      updateDOM(activeProducts);
      // } else {
      // }
      // bundleProductClose();
      updateVisibility();
    }
  });

  $(".bundle-product-cross").click(function (e) {
    e.preventDefault();
    let parent = $(this).parents(".product-bundle-add-product");
    removeActiveProduct($(parent).attr("data-vid"), $(parent).index());
  });

  $(".bundle-popup-products-filter-menu ul").on("click", "li", function () {
    var dataColHandle = $(this).attr("data-col-handle");
    $(this)
      .closest(".bundle-popup-products-block-wrapper")
      .find(".bundle-popup-products-block")
      .removeClass("active");
    $(this)
      .closest(".bundle-popup-products-block-wrapper")
      .find(`.bundle-popup-products-block[data-col-handle="${dataColHandle}"]`)
      .addClass("active");
  });
});

/* bundle builder */

document.addEventListener(
  "variant:changed",
  this.customOnVariantChange.bind(this)
);

function customOnVariantChange(e) {
  console.log("variant changed" + e.detail.variant.id);

  var elements = document.getElementsByClassName("customVariantSubTitle");
  for (var i in elements) {
    if (elements[i] && elements[i].style && elements[i].style.display) {
      elements[i].style.display = "none";
    }
  }
  var elementId = "product-variant-teaser-" + e.detail.variant.id;
  if (document.getElementById(elementId)) {
    document.getElementById(elementId).style.display = "block";
  }

  setTimeout(function () {
    var colorTexts = document.getElementById(elementId);
    
      if (
        colorTexts &&
        colorTexts.textContent &&
        colorTexts.textContent.includes("Echtgold-Plattierung")
      ) {
        var optionElement = document.getElementById("option-value-custom");
        optionElement.textContent = "Gold";
      }
      if (
        colorTexts &&
        colorTexts.textContent &&
         colorTexts.textContent.includes("Sterling Silber")
      ) {
        var optionElement = document.getElementById("option-value-custom");
        optionElement.textContent = "Silber";
      }
  }, 50);
}

document.addEventListener("scroll", function (event) {
  var annoucementBar1;
  var annoucementBar2;
  var threshold = window.location.href.includes("product")
    ? 400
    : Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
      ) / 3;

  if (!annoucementBar1 && !annoucementBar2) {
    annoucementBar2 = document.getElementById("announcement-bar");
    annoucementBar1 = document.getElementById("ed-additional-announcement-bar");
  }

  if (window.scrollY > 50 && annoucementBar2) {
    annoucementBar2.classList.add("fade");
  }

  if (window.scrollY > threshold && annoucementBar1) {
    annoucementBar1.classList.add("fade");
  }

  if (window.scrollY < 50 && annoucementBar2) {
    annoucementBar2.classList.remove("fade");
  }

  if (window.scrollY < threshold && annoucementBar1) {
    annoucementBar1.classList.remove("fade");
  }
});
